import connect from '@elab/core/store/connect';
import { actions as coreActions } from '@elab/core/store/core';
import { Form, mapFormDispatchToEvents } from '@elab/components/connected/forms/Form';
import { COMPONENT_CONNECT, COMPONENT_DISCONNECT } from '@elab/core/utils/dynaReduxHelpers';
import { selectors as globalSelectors } from '@elab/core/store/global';

import reducerCreator from './redux/reducers';
import { billingSaga, shippingSaga } from './redux/saga';
import storeNames from './storeNames';

const mapDispatchToEvents = (dispatch, ctx) => ({
    [COMPONENT_CONNECT]: () => {
        const { storeName } = ctx;
        const reducers = reducerCreator(storeName);
        let saga = null;
        let deliveryCountry = null;

        if (ctx.addShippingDestination && ctx.deliveryCountry) {
            deliveryCountry = ctx.deliveryCountry;
        }
        switch (storeName) {
            case storeNames.BILLING_ADDRESS_FORM:
                saga = billingSaga(storeName, ctx.formId, deliveryCountry);
                break;

            default:
                saga = shippingSaga(storeName, ctx.formId, deliveryCountry);
        }
        dispatch(coreActions.addReducer(storeName, reducers));
        dispatch(coreActions.addSaga(storeName, saga));
    },
    [COMPONENT_DISCONNECT]: () => {
        dispatch(coreActions.removeSaga(ctx.storeName || ctx.formId));
        dispatch(coreActions.removeReducer(ctx.storeName || ctx.formId));
    },
    ...mapFormDispatchToEvents(dispatch, ctx),
});

const mapStateToProps = state => ({
    deliveryCountry: globalSelectors.getDeliveryCountry(state),
});

export default () =>
    customElements.define(
        'e2-checkout-address-form',
        connect(mapStateToProps, mapDispatchToEvents)(Form),
    );
